module.exports = __webpack_public_path__ + "media/checkout/vipUpload-eec13b4e.svg";